import posthog from 'posthog-js';

// Utility functions for tracking user events

export const trackEvent = (eventName, properties = {}) => {
  if (typeof window !== 'undefined' && posthog) {
    posthog.capture(eventName, properties);
  }
};

export const trackPageView = (pageName, properties = {}) => {
  if (typeof window !== 'undefined' && posthog) {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      page_name: pageName,
      ...properties
    });
  }
};

export const identifyUser = (userId, userProperties = {}) => {
  if (typeof window !== 'undefined' && posthog) {
    posthog.identify(userId, userProperties);
  }
};

export const setUserProperties = (properties = {}) => {
  if (typeof window !== 'undefined' && posthog) {
    posthog.people.set(properties);
  }
};

// Common tracking events
export const tracking = {
  // App lifecycle
  appLoaded: () => trackEvent('app_loaded'),
  
  // Chat interactions
  chatStarted: () => trackEvent('chat_started'),
  messageSent: (messageType = 'text') => trackEvent('message_sent', { message_type: messageType }),
  messageReceived: () => trackEvent('message_received'),
  
  // User preferences
  preferencesOpened: () => trackEvent('preferences_opened'),
  preferencesSubmitted: (preferences) => trackEvent('preferences_submitted', preferences),
  styleSelected: (style) => trackEvent('style_selected', { style }),
  budgetSet: (budget) => trackEvent('budget_set', { budget }),
  
  // Product interactions
  productViewed: (productId, productData) => trackEvent('product_viewed', { 
    product_id: productId,
    ...productData 
  }),
  productClicked: (productId, source) => trackEvent('product_clicked', { 
    product_id: productId,
    source 
  }),
  
  // Navigation
  pageViewed: (pageName) => trackPageView(pageName),
  
  // Errors
  errorOccurred: (errorType, errorMessage) => trackEvent('error_occurred', {
    error_type: errorType,
    error_message: errorMessage
  })
};